import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { useMemo } from 'react';
import { useEffect } from 'react';
import { TOTAL_STEPS, useProjectFormStore } from '@/lib/project-form-store';
import { ProjectNewProvider } from './-components/project-new-context';
import { ProjectNewLayout } from './-components/project-new-layout';

export const Route = createFileRoute('/ngos/projects/new')({
	component: RouteComponent,
});

function RouteComponent() {
	const { t } = useLingui();
	const navigate = useNavigate();

	useEffect(() => {
		// Keep the store reset in the lazy component chunk so the route wrapper stays preload-light.
		return () => {
			useProjectFormStore.getState().reset();
		};
	}, []);

	const navigation = useMemo(
		() => ({
			toIndex: () => navigate({ to: '/ngos/projects/new' }),
			toBasic: () => navigate({ to: '/ngos/projects/new/basic' }),
			toDetails: () => navigate({ to: '/ngos/projects/new/details' }),
			toFundingType: () => navigate({ to: '/ngos/projects/new/funding-type' }),
			toFundingDetails: () => navigate({ to: '/ngos/projects/new/funding-details' }),
			toSuccess: (params?: { startDate?: string; projectId?: string }) =>
				navigate({
					to: '/ngos/projects/new/success',
					search:
						params?.startDate || params?.projectId
							? { startDate: params.startDate, projectId: params.projectId }
							: undefined,
				}),
			toCancel: () => navigate({ to: '/ngos/projects' }),
		}),
		[navigate],
	);

	return (
		<ProjectNewProvider
			value={{
				fromPortal: false,
				totalSteps: TOTAL_STEPS,
				navigation,
				breadcrumbs: [{ label: t`Projects`, onClick: navigation.toCancel }],
			}}
		>
			<ProjectNewLayout />
		</ProjectNewProvider>
	);
}
